import { AxiosPromise } from "axios"
import { usersApi } from "./api"
import { Event } from "app/models/event"

export const postEvents = (data: Event): AxiosPromise =>
  usersApi("/events", { method: "POST", data })
